import { createSlice } from '@reduxjs/toolkit';
import {json} from "../../lib/appfuse-react/core/json";

const name = 'registration';

const initialState = {
    form: {},
};

const slice = createSlice({
    name: name,
    initialState,
    reducers: {
        setRegistrationForm(state, action) {
            state.form = json.toJSON(action.payload);
        }
    }
});

export const { reducer } = slice;

export const { setRegistrationForm } = slice.actions;

export const selectRegistrationForm = state => json.fromJSON(state[name].form);

const registrationReducer = reducer;

export default registrationReducer;
